import { SectionHeader } from "./SectionHeader";
import { useI18n } from "@/i18n";

export function WhyRevolin() {
  const { t } = useI18n();

  return (
    <section id="why-revolin" className="section-y bg-slate-deep">
      <div className="container-page">
        <SectionHeader eyebrow={t.why.eyebrow} title={t.why.title} body={t.why.body} onDark />

        <ul className="mt-12 grid gap-x-10 gap-y-9 sm:grid-cols-2 lg:grid-cols-4">
          {t.why.items.map((item) => (
            <li key={item.title} className="border-t border-primary-foreground/15 pt-5">
              <h3 className="text-[0.95rem] font-semibold tracking-tight text-primary-foreground">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-primary-foreground/65">{item.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
